/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { BsModalRef} from "ngx-bootstrap/modal";
import { PermissionsService } from "../../../../services/permissions/permissions.service";
import { ConstantsService } from '../../../../services/constants/constants.service';
import { WarningModalService } from "../../../../services/warning-modal/warning-modal.service";
import { AbstractModalComponent } from "../../../abstract-modal/abstract-modal.component";
import { SMS_CONSENT_FEATURE_FLAG, isSamePhoneNumber, isUsPhoneNumber } from "../sms-consent-checkbox/sms-consent";

@Component({
  selector: 'app-xref-add-reference-recipient-modal',
  templateUrl: './xref-add-reference-recipient-modal.component.pug',
  styleUrls: ['./xref-add-reference-recipient-modal.component.scss'],
  standalone: false
})
export class XrefAddReferenceRecipientModalComponent extends AbstractModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('requestForm', {static: false}) requestForm: any;
  total = 0;
  errorMessage = {};
  errorTotalRefs = $localize`The number of total recipients for reference surveys cannot exceed 100. `
  internalReferenceTooltip = $localize`This is for internal records only and will not be shown to the candidate or referee.`
  recipient = {
    firstName: '',
    lastName: '',
    email: '',
    country_code: '',
    mobile_phone: '',
    internal_reference: '',
    sms_consent: false
  }
  disableSend = true;
  saved = false;

  mobile_number_touched: boolean = false;
  emailOutOfFocus: boolean = false;

  constructor(public _bsModalRef: BsModalRef,
    public modal: WarningModalService,
    private permissions: PermissionsService
  ) {
    super(_bsModalRef, modal);

  }

  ngOnInit(): void {
    this.checkTotalRecipients();
  }

  changeValue() {
    // making sure that either email or phone is entered before allowing data
    if (this.recipient.firstName.trim() && this.recipient.lastName.trim() && this.recipient.email && this.recipient.mobile_phone && this.recipient.internal_reference) {
      this.disableSend = false;
      this.checkTotalRecipients();
    } else this.disableSend = true;
  }

   changeValueAndCheckForRoleLength() {
    if (this.recipient.internal_reference.length > 255) {
      this.disableSend = true;
    } else {
      this.changeValue()
    }
   }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  addRecipient() {
    this.saved = true;
    if (!this.recipient.mobile_phone) this.recipient.country_code = '';
    let payload = {
      "first_name": this.recipient.firstName,
      "last_name": this.recipient.lastName,
      "email": this.recipient.email,
      "country_code": this.recipient.country_code,
      "mobile_phone": this.recipient.mobile_phone,
      "internal_reference": this.recipient.internal_reference,
      ...(this.showSmsConsent() ? {"sms_consent": this.recipient.sms_consent} : {}),
    }
    if (this.recipient.firstName && this.recipient.lastName && this.recipient.email && this.recipient.mobile_phone && this.recipient.internal_reference) {
      this.disableSend = false;
      this.checkTotalRecipients();
      this.nextClick.emit({data: payload});
      this._bsModalRef.hide();
    }
  }

  getForm() {
    return this.requestForm;
  }

  phoneUpdate(event) {
    const updatedPhone = {
      country_code: event['country_code'],
      mobile_phone: event['mobile_phone'] === 'null' ? '' : event['mobile_phone']
    };
    if (!isSamePhoneNumber(this.recipient, updatedPhone)) this.recipient.sms_consent = false;
    this.recipient.country_code = updatedPhone.country_code;
    this.recipient.mobile_phone = updatedPhone.mobile_phone;
    this.formDirty = true;
    this.changeValue();
  }

  showSmsConsent(): boolean {
    return this.permissions.isFeatureActivated(SMS_CONSENT_FEATURE_FLAG)
      && isUsPhoneNumber(this.recipient.country_code, this.recipient.mobile_phone);
  }

  setSmsConsent(granted: boolean) {
    this.recipient.sms_consent = granted;
    this.formDirty = true;
  }

  checkTotalRecipients() {
    if (this.total >= ConstantsService.REFERENCE_RECIPIENTS_LIMIT) {
      this.disableSend = true;
      this.errorMessage = {
        'type': 'danger',
        'message': this.errorTotalRefs
      };
    }
  }
}
